export default "__VITE_ASSET__CJujx3vd__"